:host {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;

  /**
   * @prop --viewer-measurement-overlays-x-axis-color: A CSS color for overlays
   * representing the X axis.
   */
  --viewer-measurement-overlays-x-axis-color: var(--x-axis-color);

  /**
    * @prop --viewer-measurement-overlays-y-axis-color: A CSS color for overlays
    * representing the Y axis.
    */
  --viewer-measurement-overlays-y-axis-color: var(--y-axis-color);

  /**
    * @prop --viewer-measurement-overlays-z-axis-color: A CSS color for overlays
    * representing the Z axis.
    */
  --viewer-measurement-overlays-z-axis-color: var(--z-axis-color);
}

.measurement-line {
  position: absolute;
  width: 100%;
  height: 100%;
}

.measurement-line.distance-vector-x {
  --viewer-measurement-line-fill: var(
    --viewer-measurement-overlays-x-axis-color
  );
}

.measurement-line.distance-vector-y {
  --viewer-measurement-line-fill: var(
    --viewer-measurement-overlays-y-axis-color
  );
}

.measurement-line.distance-vector-z {
  --viewer-measurement-line-fill: var(
    --viewer-measurement-overlays-z-axis-color
  );
}
